module.exports = __webpack_public_path__ + "static/media/check-1.fcf60e99.svg";